import React, { useState, useContext } from 'react'
import ApiService from '../../services/ApiService'
import { useProfileContext } from '../../contexts/AccessesContext'
import ModalContext from '../../contexts/ModalContext'
import cross from '../../assets/close-icon.svg'
import {
  Container, HeaderText, CloseDiv, CloseImg, ContentWrapper,
  InputLabel, Input, ButtonsContainer, CancelButton, SaveButton
} from './style'

const CreateAFunctionModal = () => {
  const { setModalActive } = useContext(ModalContext)
  const { setNewFunctions } = useProfileContext()
  const [_function, setFunction] = useState('')

  const createFunction = () => {
    const formData = {
      name: _function
    }
    ApiService.productionFlow.createFunction(formData)
      .then((response: any) => {
        console.log(response)
        setModalActive(false)
        if (setNewFunctions) {
          setNewFunctions((prev: number) => prev + 1)
        }
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  return (
    <Container>
      <HeaderText>Criar função</HeaderText>
      <CloseDiv onClick={() => setModalActive(false)}>
        <CloseImg src={cross} />
      </CloseDiv>
      <ContentWrapper>
        <InputLabel>Nome:</InputLabel>
        <Input
          value={_function}
          autoFocus
          onChange={(e) => setFunction(e.target.value)}
          placeholder={'Nome da função...'}
        />
      </ContentWrapper>
      <ButtonsContainer>
        <CancelButton onClick={() => setModalActive(false)}>Voltar</CancelButton>
        <SaveButton onClick={createFunction}>Criar</SaveButton>
      </ButtonsContainer>
    </Container>
  )
}

export default CreateAFunctionModal
